// utils/officeUtils.ts (or similar)

export enum HostEnvironment {
    Outlook = 'Outlook',
    Word = 'Word',
    Excel = 'Excel',
    PowerPoint = 'PowerPoint',
    Project = 'Project',
    Access = 'Access', // If applicable
    OneNote = 'OneNote', // If applicable
    WebBrowser = 'WebBrowser',
    Unknown = 'Unknown',
  }
  
  export function getOfficeHostEnvironment(): HostEnvironment {
    try {
      if (window.Office && window.Office.context && window.Office.context.host) {
        switch (window.Office.context.host) {
          case Office.HostType.Outlook:
            return HostEnvironment.Outlook;
          case Office.HostType.Word:
            return HostEnvironment.Word;
          case Office.HostType.Excel:
            return HostEnvironment.Excel;
          case Office.HostType.PowerPoint:
            return HostEnvironment.PowerPoint;
          case Office.HostType.Project:
              return HostEnvironment.Project;
          // Add other Office.HostType cases if needed
          default:
            return HostEnvironment.Unknown; // An Office host, but not one we explicitly check
        }
      } else {
        return HostEnvironment.WebBrowser; // Office object not found, assume standard web browser
      }
    } catch (error) {
      console.error("Error detecting Office host environment:", error);
      return HostEnvironment.WebBrowser; // Fallback on error
    }
  }
  
  export function isRunningInOutlook(): boolean {
    return getOfficeHostEnvironment() === HostEnvironment.Outlook;
  }
  
  export function isRunningInOffice(): boolean {
    const env = getOfficeHostEnvironment();
    return env !== HostEnvironment.WebBrowser && env !== HostEnvironment.Unknown;
  }